import {observer} from 'mobx-react-lite'
import React, {useRef} from 'react'
import {StickerColor} from 'yougile-model'
import {StickerStringStateEditor} from '@components/sticker/my-stickers/sticker-editor/string-state-edit/sticker-string-state-editor'
import {useClickAway} from '@containers/hooks'
import IconArrow from '../../common/icons/icons-common/icon-arrow.svg'
import IconDots from '../../common/icons/icons-common/icon-dots.svg'
import {useStickerEditorStore} from '../sticker-editor-store'

export const StringStateEdit = observer(() => {
  const ref = useRef<HTMLInputElement>(null)
  const [state, store] = useStickerEditorStore()

  const cancel = (): void => {
    store.cancelStringState()
  }

  const onClickOutside = (): void => {
    if (state.stringStateName) {
      store.saveStringState()
    } else {
      cancel()
    }
  }

  const onEnterSave = (): void => {
    store.saveStringState({openNewEditAfterSave: true})
  }

  useClickAway(ref, onClickOutside)

  const stateColor = state.stringState?.color

  const onClickOnColor = (color: StickerColor): void => {
    store.setStickerChanged(true)
    const st = {...state.stringState, color}
    store.setStringState(st)
  }

  return (
    <div className="flex items-center gap-4 w-min relative">
      <IconDots className="flex shrink-0 text-third-old" />
      <div className={`flex text-third-old text-${stateColor}`}>
        <IconArrow />
      </div>
      <StickerStringStateEditor
        ref={ref}
        value={state.stringStateName}
        onChange={store.setStringStateName}
        onEnterSave={onEnterSave}
        cancel={cancel}
        onSave={store.saveStringState}
        onClickOnColor={onClickOnColor}
        selectedColor={state.stringState?.color}
        icon={state.stickerIcon}
      />
    </div>
  )
})
